import React from "react";
import i18n from "../../../constants/i18n";
import getCorePopUpStore from "../../../stores/core/core-popup-store";
import getKhattabat102GeneralStore from "../../../stores/khattabat-stores/102-stores/general-102-store";
import getKhattabat102Store from "../../../stores/khattabat-stores/102-stores";
import ET3Div from "../../et3-div";
import Et3Button from "../../et3-button";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import Et3Text from "../../et3-text";
import Et3Margin from "../../et3-ui/ET3Margin";
import { KhattabatOneOTwoHistoryColumn } from "./KhattabatOneOTwoHistoryColumn";

const KhattabatOneOTwoMessageHistoriesPopUp = withLiteObserverAndTheme(
  (props) => {
    const { theme } = props;
    const { colors, unitX, unitY } = theme;
    const khattabat102GeneralStore = getKhattabat102GeneralStore();
    const conversationID =
      khattabat102GeneralStore.getSelectedHistoryConversationID();
    const messageId = khattabat102GeneralStore.getSelectedHistoryMessageId();
    const khattabat102Store = getKhattabat102Store(conversationID);

    const {
      senderID,
      recipientID,
      senderGender,
      recipientGender,
      isKhattabaAuthored,
      senderEvents,
      recipientEvents
    } = khattabat102Store.getMessageHistoryColumns(messageId);

    return (
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={1500}
        height={1080}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={colors.all.transparentGray}
        style={{
          position: "fixed",
          top: 0,
          zIndex: 5
        }}
        onClick={() => {}}
      >
        <ET3Div
          isScrollable={false}
          isExtendable={true}
          fDirection="column"
          justifyContent="flex-start"
          alignItems="center"
          withShadow={true}
          width={1000}
          height={0}
          color={colors.all.white}
          style={{
            position: "relative",
            borderRadius: 50,
            zIndex: 5,
            overflow: "hidden"
          }}
          onClick={() => {}}
        >
          <Et3Margin top={30} bottom={0} left={0} right={0} />
          <Et3Text
            fontFamily={"BOLD"}
            fontSize={32}
            isSpan={false}
            text={i18n.get("KHATTABAT_ONE_O_TWO_HISTORIES_POPUP_TITLE")}
            color={colors.all.black}
            style={{}}
          />
          <Et3Margin top={30} bottom={0} left={0} right={0} />
          <ET3Div
            isScrollable={true}
            isExtendable={true}
            fDirection="column"
            justifyContent="flex-start"
            alignItems="center"
            withShadow={false}
            width={900}
            height={0}
            color={colors.all.transparent}
            style={{
              maxHeight: 500 * unitY,
              borderRadius: 20 * unitX
            }}
            onClick={() => {}}
          >
            {senderEvents.length === 0 && recipientEvents.length === 0 ? (
              <ET3Div
                isScrollable={false}
                isExtendable={false}
                fDirection="row"
                justifyContent="center"
                alignItems="center"
                withShadow={false}
                width={900}
                height={100}
                color={colors.all.transparent}
                style={{}}
                onClick={() => {}}
              >
                <Et3Text
                  fontFamily={"MEDIUM"}
                  fontSize={20}
                  isSpan={false}
                  text={i18n.get("NO_RESULT")}
                  color={colors.all.dimGray}
                  style={{}}
                />
              </ET3Div>
            ) : (
              <React.Fragment>
                {isKhattabaAuthored ? (
                  <ET3Div
                    isScrollable={false}
                    isExtendable={false}
                    fDirection="row"
                    justifyContent="center"
                    alignItems="center"
                    withShadow={false}
                    width={900}
                    height={50}
                    color={colors.all.paleBluishGray}
                    style={{}}
                    onClick={() => {}}
                  >
                    <Et3Text
                      fontFamily={"BOLD"}
                      fontSize={20}
                      isSpan={false}
                      text={i18n.get(
                        "KHATTABAT_ONE_O_TWO_HISTORY_SENDER_KHATTABA"
                      )}
                      color={colors.all.black}
                      style={{}}
                    />
                  </ET3Div>
                ) : null}
                <ET3Div
                  isScrollable={false}
                  isExtendable={true}
                  fDirection="row"
                  justifyContent="center"
                  alignItems="flex-start"
                  withShadow={false}
                  width={900}
                  height={0}
                  color={colors.all.transparent}
                  style={{}}
                  onClick={() => {}}
                >
                  <KhattabatOneOTwoHistoryColumn
                    columnTitle={i18n.get("KHATTABAT_ONE_O_TWO_HISTORY_SENDER")}
                    participantID={senderID}
                    historyEvents={senderEvents}
                    rowColor={
                      senderGender === "m"
                        ? colors.all.paleSkyBlue
                        : colors.all.palePink
                    }
                    withColumnHeader={!isKhattabaAuthored}
                  />
                  <KhattabatOneOTwoHistoryColumn
                    columnTitle={i18n.get(
                      "KHATTABAT_ONE_O_TWO_HISTORY_RECIPIENT"
                    )}
                    participantID={recipientID}
                    historyEvents={recipientEvents}
                    rowColor={
                      recipientGender === "m"
                        ? colors.all.paleSkyBlue
                        : colors.all.palePink
                    }
                    withColumnHeader={!isKhattabaAuthored}
                  />
                </ET3Div>
              </React.Fragment>
            )}
          </ET3Div>
          <Et3Margin top={30} bottom={30} left={0} right={0} />
          <Et3Button
            isEnabled={true}
            onClick={() => {
              getCorePopUpStore().closeConfirmationPopUps();
            }}
            type="GET"
            size="LARGE"
            text="OK"
          />
          <Et3Margin top={30} bottom={0} left={0} right={0} />
        </ET3Div>
      </ET3Div>
    );
  }
);
export default KhattabatOneOTwoMessageHistoriesPopUp;
